import { registerLocale } from "react-datepicker";
import nl from "date-fns/locale/nl";
import fr from "date-fns/locale/fr";
import de from "date-fns/locale/de";
import es from "date-fns/locale/es";
import ru from "date-fns/locale/ru";
import pt from "date-fns/locale/pt";
import ja from "date-fns/locale/ja";
import zhCN from "date-fns/locale/zh-CN";
import enGB from "date-fns/locale/en-GB";
import cropr from "../../shared/utils/cropr";

// Mirror the set of moment locales cropr imports in shared/utils/i18n.js so
// the picker month names / day labels match the rest of the UI.
registerLocale("nl", nl);
registerLocale("fr", fr);
registerLocale("de", de);
registerLocale("es", es);
registerLocale("ru", ru);
registerLocale("pt", pt);
registerLocale("ja", ja);
registerLocale("zh-cn", zhCN);
registerLocale("en", enGB);

// Resolve cropr's languageCode to a registered react-datepicker locale name.
// Unknown codes fall back to the English registration so the picker still
// renders localized rather than using date-fns's default US English.
export const currentDatePickerLocale = () => {
  const code = (cropr && cropr.l10n && cropr.l10n.languageCode) || "en";
  const normalized = code.toLowerCase();
  const registered = ["nl", "fr", "de", "es", "ru", "pt", "ja", "zh-cn", "en"];
  return registered.includes(normalized) ? normalized : "en";
};
